<template>
  <div class="login">
    <card header-text="Recuperación de contraseña">
      <div slot="card-pre-header">
        <router-link :to="{name: 'login'}" title="Volver atrás">
          <font-awesome-icon icon="arrow-circle-left" class="mr-2" />
        </router-link>
      </div>
      <div class="card-body card-block">
        <formio
          ref="recuperarClaveFormio"
          :form="recuperarClaveFormio"
          :options="optionsFormio"
          @submit="onSubmit"
          @error="onError"
        >
        </formio>
      </div>
    </card>
  </div>
</template>

<script>
import { Form } from 'vue-formio'
import recuperarClaveFormio from './formio/recuperarClave'
import { restorePass } from '../../api/auth'

export default {
  name: 'RecuperarClave',
  components: { formio: Form },
  data () {
    return {
      loading: false,
      optionsFormio: {
        noAlerts: true
      }
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  methods: {
    onSubmit (form) {
      restorePass(form.data.email)
        .then((response) => {
          alert('Se envió el email de recuperación al correo: ' + form.data.email)
          this.$router.push({ path: '/' })
        })
        .catch((err) => {
          if (err.code === 'auth/user-not-found') {
            alert('Usuario no existe')
          }
        })
    },
    onError (err) {
      console.error(err)
    }
  },
  computed: {
    recuperarClaveFormio () {
      return recuperarClaveFormio
    }
  }
}
</script>
